export default "__VITE_ASSET__225652a1__"